module.exports = "pegasus/assets/hexagon-twitter.gif";